<template>
  <div>
    <portal to="page-top-title">Edit Category #{{ id }}</portal>
    <portal to="page-top-right">
      <btn :route="{ name: 'badwords-categories-single', params: { id: id } }" icon="fa-eye" text>Back to Category</btn>
    </portal>

    <box-form action="edit" data-prop="formData" redirect="badwords-categories-single" :url="`/badwords/categories/${id}`" :loaded="loaded" loader>
      <template slot="content">
        <row>
          <column-input>
            <form-group-input name="name" :model="formData.name" :min="3" required/>
          </column-input>
          <column-input :md="2">
            <form-group-check name="active" :model="formData.active"/>
          </column-input>
        </row>
      </template>
    </box-form>
  </div>
</template>

<script>
import BoxForm from '@/views/components/data/BoxForm'
import Btn from '@/views/components/simple/Btn'
import FormGroupCheck from '@/views/components/form/FormGroupCheck'
import FormGroupInput from '@/views/components/form/FormGroupInput'
import Form from '@/modules/utils/Form'

export default {
  name: 'BadwordsCategoriesEdit',
  metaInfo () {
    return { title: `Badwords | Category #${this.id} | Edit` }
  },
  components: {
    BoxForm,
    FormGroupCheck,
    Btn,
    FormGroupInput
  },
  computed: {
    id () { return this.$route.params.id }
  },
  data () {
    return {
      loaded: false,
      formData: {
        name: Form.types.input(),
        active: Form.types.boolean()
      }
    }
  },
  created () {
    this.loadEntity()
  },
  methods: {
    loadEntity () {
      this.$http
        .get(`/badwords/categories/${this.id}`, { params: { with_meta: 1 } })
        .then((res) => {
          const { data: { data } } = res

          this.formData.name.value = data.name
          this.formData.active.value = data.active

          this.loaded = true
        })
    }
  }
}
</script>
